import { render } from "./RegisterStep2.vue?vue&type=template&id=b2a3370c&scoped=true"
import script from "./RegisterStep2.vue?vue&type=script&lang=js"
export * from "./RegisterStep2.vue?vue&type=script&lang=js"

import "./RegisterStep2.vue?vue&type=style&index=0&id=b2a3370c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2653157369/src/mchanga-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a3370c"]])

export default __exports__